module.exports = __webpack_public_path__ + "img/bg3.2dd3cc60.jpg";